export const state = {
  testTypePage: {
    testTypes: []
  }
};

import Vue from 'vue';
import axios from 'axios';

export const namespaced = true;

export const mutations = {
  //test type pages-----------------------------------------------------------------------

  SET_TEST_TYPES(state, payload) {
    state.testTypePage.testTypes = payload;
  },

  UPDATE_TEST_TYPE(state, payload) {
    let itemIndex;
    state.testTypePage.testTypes.forEach((item, i) => {
      if (item.id == payload.testId) itemIndex = i;
    });
    Vue.set(state.testTypePage.testTypes, itemIndex, payload.testTypeData);
  }
};

export const actions = {
  async createTestType({ rootState, dispatch }, payload) {
    return await axios
      .post(`${rootState.baseUrlApi}/labhoh-restful-api/testtype`, payload)
      .then(async res => {
        if (res.status == 204 || res.status == 200) {
          await dispatch('getTestTypes');
          return true;
        } else return false;
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error saving test type', { root: true });
        return false;
      });
  },
  async getTestTypes({ rootState, dispatch, commit }) {
    return await axios
      .get(`${rootState.baseUrlApi}/labhoh-restful-api/testtype`)
      .then(res => {
        if (res.status == 204 || res.status == 200) commit('SET_TEST_TYPES', res.data);
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error getting test type data', { root: true });
        return false;
      });
  },

  async deleteTestType({ rootState, dispatch }, id) {
    return await axios
      .delete(`${rootState.baseUrlApi}/labhoh-restful-api/testtype/${id}`)
      .then(async res => {
        if (res.status == 204 || res.status == 200) {
          await dispatch('getTestTypes');
          return true;
        } else return false;
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Cannot delete test type due to constraint', { root: true });
        return false;
      });
  },

  async updateTestType({ rootState, dispatch, commit }, payload) {
    return await axios
      .put(`${rootState.baseUrlApi}/labhoh-restful-api/testtype/${payload.testId}`, payload.testTypeData)
      .then(res => {
        if (res.status == 204 || res.status == 200) {
          commit('UPDATE_TEST_TYPE', payload);
        }
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error saving test type', { root: true });
        return false;
      });
  }
};

export const getters = {
  testTypes: state => {
    return state.testTypePage.testTypes;
  }
};
